export const environment = {
  production: false,
  apiUrl: 'https://dev.back.graph.redcrossquest.com',
  supersetUrl: 'https://dev.superset.graph.redcrossquest.com',
  rcqV1Url: 'https://dev.redcrossquest.croix-rouge.fr',
  // Set to true to enable Superset embedded dashboards (requires Superset Cloud Run service)
  enableSuperset: false,
  environmentLabel: 'DEV',
};
